import { render, staticRenderFns } from "./confimePwd.vue?vue&type=template&id=2c6302ea&scoped=true"
import script from "./confimePwd.vue?vue&type=script&lang=js"
export * from "./confimePwd.vue?vue&type=script&lang=js"
import style0 from "./confimePwd.vue?vue&type=style&index=0&id=2c6302ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6302ea",
  null
  
)

export default component.exports